(function () {
  angular.module('rightPaneModule')
    .controller('GuardianAssignmentHistoryController', [
      '$scope',
      'assignedFocusApi',
      '$state',
      'minutesFilter',
      '$window',
      '$modal',
      'standard',
      'authentication',
      'dblStandardsFactoryService',
      'moment',
      'progressApi',
      'dblAnalyticsProvider',
      GuardianAssignmentHistoryController]);

  function GuardianAssignmentHistoryController(
    $scope,
    $assignedFocusApi,
    $state,
    $minutesFilter,
    $window,
    $modal,
    $standard,
    dblAuthentication,
    dblStandardsFactoryService,
    moment,
    progressApi,
    $analytics
  ) {

    $scope.studentId = $state.params.studentId;
    $scope.assignmentHistoryLegendUrl = 'resources/right-pane/partials/assignment-history-legend.html';
    $scope.assignmentSupportArticleUrl = 'https://dreamboxlearning.zendesk.com/hc/en-us/articles/27281501967251-DreamBox-Math-Family-Dashboard-Assignments-Home-Subscribers';

    $scope.busy = true;

    var districtId = $state.params.studentDistrictId ? $state.params.studentDistrictId : $state.params.districtId;
    $scope.studentHistoryExportUrl = "/r/districts/" + districtId + "/students/" + $state.params.studentId + "/assignments?format=csv";

    $standard.resetParams();

    var customer = dblAuthentication.getCustomer();
    $scope.allowAddAssignment = $state.params.studentDistrictId === '-1' || customer.hasTag('ASSIGN_FOCUS_ENABLED');

    function isAssignmentActive(assignment) {
      return assignment.status === 'ACTIVE' && !_.startsWith(assignment.student_status, "COMPLETE") &&
        !_.startsWith(assignment.student_status, "REMOVED");
    }

    function updateAssignmentHistory() {
      $assignedFocusApi.getStudentAssignedLessonsHistory($state.params.studentId, function (history) {
        history = history.assignments;
        $assignedFocusApi.appendFocusData(history).then(function (assignments) {

          if (history.length > 0) {
            $scope.student = history[0].first_name + " " + history[0].last_name;

            var studentId = $state.params.studentId;
            var classrooms = {};
            _.forEach(assignments, function (assignment) {
              classrooms[assignment.classroom_id] = assignment.classroom_id;

              assignment.collapsed = true;

              assignment.time_spent_mins = $minutesFilter(assignment.time_spent, true);
              assignment.tutorial_time_spent_mins = $minutesFilter(assignment.tutorial_time_spent, true);

              assignment.lesson_class = $assignedFocusApi.determineLessonClass(assignment.student_assignment_histories);
              assignment.lesson_goal_name = $assignedFocusApi.validateLessonGoalName(assignment.lesson_goal_name);

              assignment.show_duration = assignment.time_spent > 0 || assignment.status !== 'ACTIVE';

              var focusType = assignment.focus_type;
              var focusId = assignment.focus_id;
              var toDate = moment(assignment.end_date).format('YYYYMMDD');

              if (isAssignmentActive(assignment) && (focusType === 'DOMAIN' || focusType === 'CLUSTER')) {
                progressApi.getGoalStandardProgressForStudent(districtId, studentId, focusType, focusId, toDate).then(function (clusterData) {
                  var clusters;

                  if (focusType === 'DOMAIN') {
                    clusters = clusterData.clusters;
                  } else {
                    clusters = [_.find(clusterData.clusters, {code: focusId.toString()})];
                  }

                  assignment.standards = dblStandardsFactoryService.createStandardsForClusters(clusters);
                });
              }
            });


            $scope.showClassroom = Object.keys(classrooms).length > 1;
          }

          $scope.activeAssignments = _.filter(history, function (assignment) {
            return isAssignmentActive(assignment);
          });

          $scope.assignmentHistory = _.reject(history, function (assignment) {
            return isAssignmentActive(assignment);
          });

          $scope.busy = false;
        });
      });
    }

    function initializeData(e, item) {
      $scope.busy = true;
      $scope.item = item;
      if (!$scope.item) {
        return;
      }

      updateAssignmentHistory();
    }

    function cancelAssignment(assignment) {
      var cancelled = {};
      cancelled.assignment_id = assignment.assignment_id;
      cancelled.lessons_assigned = assignment.lessons_assigned;
      cancelled.start_date = assignment.start_date;

      $analytics.eventTrack('Assignment Canceled', {
        category: 'Assign Focus',
        label: $scope.item.type
      });

      $assignedFocusApi.cancelStudentLesson([parseInt($state.params.studentId)], cancelled, function () {
        // success
        assignment.status = 'CANCELLED';

        $scope.activeAssignments = _.reject($scope.activeAssignments, function (activeAssignment) {
          return activeAssignment.assignment_id === assignment.assignment_id;
        });
      }, function () {
        // error
        console.warn('There was an error with cancelling your assignment');
      });
    }

    function cancelAssignmentClicked(e, assignment) {
      verify(assignment);
    }

    function verify(assignment) {
      var modal = $modal.open({
        templateUrl: 'resources/core/partials/verify-cancel-assignment.html',
        windowClass: 'common-modal verify-modal',
        controller: 'VerifyCancelAssignmentModalController',
        scope: $scope,
        resolve: {
          lessonData: function () {
            return assignment;
          }
        }
      });

      // Handle the modal response from the user
      modal.result.then(function () {
        // Cancel
        cancelAssignment(assignment);
      }, function () {
        // Don't Cancel

      });
    }

    function viewProgressClicked(e, assignment) {
      var modal = $modal.open({
        templateUrl: 'resources/core/partials/student-progress-modal.html',
        windowClass: 'fill-view-modal student-progress-modal',
        controller: 'StudentProgressModalController',
        backdrop: 'static',
        scope: $scope,
        resolve: {
          progressData: function () {
            var data = $assignedFocusApi.createProgressDataFromAssignment(assignment);
            data.grade = $scope.item.grade;
            data.districtId = districtId;

            return data;
          }
        }
      });
    }

    function updateStudentDataForGuardian(e) {
      if ($scope.studentId !== $state.params.studentId) {
        $state.reload();
      }
    }

    $scope.$on('itemReady', initializeData);
    $scope.$on('cancelAssignmentClicked', cancelAssignmentClicked);
    $scope.$on('viewProgressClick', viewProgressClicked);

    $scope.$on('updateStudentDataForGuardian', updateStudentDataForGuardian);
  }
})();
